import { render, staticRenderFns } from "./LayoutNavigation.vue?vue&type=template&id=c381350a&"
import script from "./LayoutNavigation.vue?vue&type=script&lang=js&"
export * from "./LayoutNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c381350a')) {
      api.createRecord('c381350a', component.options)
    } else {
      api.reload('c381350a', component.options)
    }
    module.hot.accept("./LayoutNavigation.vue?vue&type=template&id=c381350a&", function () {
      api.rerender('c381350a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/layout/LayoutNavigation.vue"
export default component.exports